"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var remote_followed_groups_1 = __importDefault(require("../constants/actions/remote-followed-groups"));

var followed_status_1 = __importDefault(require("../constants/followed-status"));

var api_1 = __importDefault(require("../api"));

var UtilsRemoteFollowedGroups = __importStar(require("../utils/remote-followed-groups"));

function getList() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var prevList, list, nextList;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: remote_followed_groups_1.default.FETCH_INIT
                });
                _context.prev = 1;
                prevList = getState().remoteFollowedGroups.list;
                _context.next = 5;
                return api_1.default.FollowedGroups.getList();

              case 5:
                list = _context.sent;
                nextList = UtilsRemoteFollowedGroups.sortByEditAt(lodash_1.default.unionBy(lodash_1.default.concat(list, prevList), 'id'));
                dispatch({
                  type: remote_followed_groups_1.default.FETCH_SUCCESS,
                  list: nextList
                });
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: remote_followed_groups_1.default.FETCH_FAILURE,
                  error: _context.t0
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

exports.getList = getList;

function reload() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var list;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: remote_followed_groups_1.default.RELOAD_INIT
                });
                _context2.prev = 1;
                _context2.t0 = UtilsRemoteFollowedGroups;
                _context2.next = 5;
                return api_1.default.FollowedGroups.reload();

              case 5:
                _context2.t1 = _context2.sent;
                list = _context2.t0.sortByEditAt.call(_context2.t0, _context2.t1);
                dispatch({
                  type: remote_followed_groups_1.default.RELOAD_SUCCESS,
                  list: list
                });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t2 = _context2["catch"](1);
                dispatch({
                  type: remote_followed_groups_1.default.RELOAD_FAILURE,
                  error: _context2.t2
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 10]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

exports.reload = reload;

function follow(groupId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch({
                  type: remote_followed_groups_1.default.FOLLOW_INIT,
                  group_id: groupId
                });
                _context3.prev = 1;
                _context3.next = 4;
                return api_1.default.FollowedGroups.follow(groupId);

              case 4:
                data = _context3.sent;
                dispatch({
                  type: remote_followed_groups_1.default.FOLLOW_SUCCESS,
                  data: data,
                  group_id: groupId,
                  followed_status: followed_status_1.default.FOLLOWED
                });
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                dispatch({
                  type: remote_followed_groups_1.default.FOLLOW_FAILURE,
                  error: _context3.t0
                });

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 8]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

exports.follow = follow;

function unfollowById(id) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch, getState) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch({
                  type: remote_followed_groups_1.default.UNFOLLOW_BY_ID_INIT,
                  id: id
                });
                _context4.prev = 1;
                _context4.next = 4;
                return api_1.default.FollowedGroups.unfollowById(id);

              case 4:
                dispatch({
                  type: remote_followed_groups_1.default.UNFOLLOW_BY_ID_SUCCESS,
                  id: id
                });
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](1);
                dispatch({
                  type: remote_followed_groups_1.default.UNFOLLOW_BY_ID_FAILURE,
                  error: _context4.t0
                });

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 7]]);
      }));

      return function (_x7, _x8) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}

exports.unfollowById = unfollowById;

function unfollow(groupId) {
  return function (dispatch, getState) {
    dispatch({
      type: remote_followed_groups_1.default.UNFOLLOW_INIT,
      group_id: groupId
    });

    try {
      api_1.default.FollowedGroups.unfollow(groupId).then(function () {
        dispatch({
          type: remote_followed_groups_1.default.UNFOLLOW_SUCCESS,
          group_id: groupId,
          followed_status: followed_status_1.default.NOT_FOLLOWED
        });
      });
    } catch (error) {
      dispatch({
        type: remote_followed_groups_1.default.UNFOLLOW_FAILURE,
        error: error
      });
    }
  };
}

exports.unfollow = unfollow;